module.exports = __webpack_public_path__ + "img/habitat_2.33dbf360.jpg";